<template>
    <b-input-group>
        <b-input-group-prepend class="input-group-icon" v-if="leftIcon">
            <b-input-group-text>
                <font-awesome-icon :icon="leftIcon"></font-awesome-icon>
            </b-input-group-text>
        </b-input-group-prepend>
        <b-input-group-prepend v-if="leftText" is-text>{{ leftText }}</b-input-group-prepend>
        <slot></slot>
        <b-input-group-append v-if="rightText" is-text>{{ rightText }}</b-input-group-append>
         <b-input-group-prepend class="input-group-icon" v-if="rightIcon">
            <b-input-group-text class="right-icon-wrapper">
                <font-awesome-icon :icon="rightIcon"></font-awesome-icon>
            </b-input-group-text>
        </b-input-group-prepend>
    </b-input-group>
</template>

<script>
    export default {
        name: 'FormInputGroup',
        props: {
            leftIcon: [Object, Array, String],
            leftText: String,
            rightIcon: [Object, Array, String],
            rightText: String,
        },
    };
</script>

<style lang="scss" scoped>
    // set stable width for the left icon box in order to have evenly aligned floating labels
    .right-icon-wrapper {
        margin: 0;
        border-top-right-radius: .25rem !important;
        border-bottom-right-radius: .25rem !important;
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
        border-left: none !important;
    }
    :deep(.input-group-icon .input-group-text) {
        width: 2.6rem;
    }
</style>
